import { render, staticRenderFns } from "./report-printing.page.vue?vue&type=template&id=ed556e16"
import script from "./report-printing.page.vue?vue&type=script&lang=ts"
export * from "./report-printing.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports